import React, { useCallback, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Drawer from "@mui/material/Drawer";
import TextField from "@mui/material/TextField";

import FormHeader from "views/components/formheader";
import FormButtons from "views/components/formbuttons";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { isSpaceValidateTextField } from "@core/utils/Const";

const AddLibraryCategory = (props) => {
  const {
    open,
    toggle,
    type,
    heading,
    onSubmitCategory,
    updateData,
    onHandleUpdate,
  } = props;

  const defaultValues = {
    category: "",
  };

  const {
    setValue,
    reset,
    control,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues });

  const resetToEmptyValues = useCallback(() => {
    setValue("category", "");
  }, [setValue]);

  const resetToStoredValues = useCallback(() => {
    if (type === "edit") {
      const event = {
        category: updateData.cat_name,
      };
      setValue("category", event.category || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, type]);

  useEffect(() => {
    if (type === "edit") {
      resetToStoredValues();
    } else {
      resetToEmptyValues();
    }
  }, [open, resetToStoredValues, resetToEmptyValues, type]);

  const handleClose = () => {
    clearErrors();
    if (type === "add") {
      reset(defaultValues);
    }
    toggle();
  };

  const onSubmit = (data) => {
    if (type === "add") {
      const payload = {
        name: data.category,
      };
      APICall("post", payload, EndPoints.addLibraryCategory)
        .then((response) => {
          const { isError, message } = response.data;
          if (!isError) {
            toast.success(message);
            onSubmitCategory();
            handleClose();
          } else {
            toast.error(message);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      const payload = {
        id: updateData.id,
        name: data.category,
      };
      APICall("post", payload, EndPoints.updateLibraryCategory)
        .then((response) => {
          const { isError, data, message } = response.data;
          if (!isError) {
            toast.success(message);
            onHandleUpdate(data[0]);
            handleClose();
          } else {
            toast.error(message);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  };

  return (
    <Drawer
      open={open}
      anchor="right"
      variant="temporary"
      onClose={handleClose}
      ModalProps={{ keepMounted: true }}
      sx={{ "& .MuiDrawer-paper": { width: { xs: 300, sm: 400 } } }}
    >
      <FormHeader heading={heading} onClick={handleClose} />
      <Box sx={{ p: 5 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Controller
                  name="category"
                  control={control}
                  rules={{
                    required: true,
                    validate: isSpaceValidateTextField,
                  }}
                  render={({ field: { value, onChange } }) => (
                    <TextField
                      value={value}
                      onChange={onChange}
                      fullWidth
                      type="text"
                      label="Category"
                      error={Boolean(errors.category)}
                      placeholder="Enter category"
                      aria-describedby="validation-basic-first-name"
                    />
                  )}
                />
                {errors.category && (
                  <FormHelperText
                    sx={{ color: "error.main" }}
                    id="validation-basic-select"
                  >
                    This field is required
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <FormButtons type={type} resetFunction={resetToEmptyValues} />
          </Grid>
        </form>
      </Box>
    </Drawer>
  );
};

export default AddLibraryCategory;
